import styled from 'styled-components';

export const Container = styled.section<{
  dateValue: Date | undefined;
  readOnlyInput?: boolean;
}>`
  width: 100%;
  min-width: 160px !important;

  .react-date-picker {
    width: 100%;

    .react-date-picker__wrapper {
      padding: 0 16px;
      height: 48px;

      border: 1px solid #cccbcc;
      border-radius: 8px;

      background-color: #fff;

      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus-within {
        border-color: ${({ theme }) => theme.colors.orange.primary};
        box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
      }

      font-weight: 400;
      font-size: 13px;

      width: 100%;

      justify-content: space-between;

      button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 1;
      }
      button::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: ${({ readOnlyInput }) =>
          readOnlyInput ? '100%' : '0%'} !important;
        height: ${({ readOnlyInput }) =>
          readOnlyInput ? '100%' : '0%'} !important;
        background-color: transparent;
      }

      .react-date-picker__inputGroup {
        max-width: fit-content !important;
        padding: 0 2px;

        pointer-events: ${({ readOnlyInput }) =>
          readOnlyInput ? 'none' : ''} !important;

        span,
        .react-date-picker__inputGroup__input {
          color: ${({ theme }) => theme.colors.gray[500]};
          outline: none;
        }
      }
    }
  }

  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__month,
  .react-date-picker__inputGroup__year {
    display: ${({ dateValue }) => (!dateValue ? 'none' : null)};
  }

  .react-calendar__navigation__label__labelText {
    font-size: 14px;
    font-weight: bold;
    color: black !important;
  }

  .react-calendar__tile--now {
    background: ${({ theme }) => theme.colors.primary[70]};
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${({ theme }) => theme.colors.orange.primary};
    color: #fff;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background: ${({ theme }) => theme.colors.primary[70]};
  }
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;
